import React, { useState } from 'react';
import { ListChecks, Table2 } from 'lucide-react';
import SimpleAccessEditor from './SimpleAccessEditor';
import AccessMatrixEditor from './AccessMatrixEditor';
import styles from './SimpleAccess.module.css';

/**
 * Two views of the same access:
 *   By module  (default) View / Create / Edit / Delete + options per module
 *   Advanced   every button and rule, one switch each
 * Same props as AccessMatrixEditor.
 */
export default function AccessEditor(props) {
    const [advanced, setAdvanced] = useState(false);
    return (
        <div>
            <div className={styles.viewSwitch} role="tablist" aria-label="Access view">
                <button type="button" role="tab" aria-selected={!advanced} className={!advanced ? styles.viewOn : ''} onClick={() => setAdvanced(false)}>
                    <Table2 size={13} /> By module
                </button>
                <button type="button" role="tab" aria-selected={advanced} className={advanced ? styles.viewOn : ''} onClick={() => setAdvanced(true)}>
                    <ListChecks size={13} /> Advanced
                </button>
            </div>
            {advanced ? <AccessMatrixEditor {...props} /> : <SimpleAccessEditor {...props} />}
        </div>
    );
}